export default __webpack_public_path__ + "static/media/opensea.48f964c7.svg";